<template>
	<div>
		<h2>Usuarios</h2>
        <a @click="$router.go(-1)">regresar</a>
        <br><br>
		<router-link id='agrega' :to="{name: 'agre-usu'}">Agregar</router-link>
		<br>
		<br>
		<ul id='usuarios-lista' v-if="usuariosTodos !=null" >
			<li v-for="usuari in usuariosTodos">	
				<strong>
					<p>{{usuari.nombreCompleto}}</p>
					<p>{{usuari.mail}}</p>

					<p>{{usuari.celular}}</p>
					<p>{{usuari.whatsapp}}</p>
					<p>status: {{usuari.status}}</p>

				</strong>
				<br>
			   <p>
					<router-link id='editar':to="{name: 'edi-usu', params:{idparam:usuari.idu}}">Editar</router-link>
			   </p>
  			</li>
		</ul>
		
		<span v-else>Cargando usuarios...</span>
	</div>
</template>


<script>
import axios from 'axios';

export default {
  name: 'Usuarios',
  mounted(){
  	this.getUsuarios();
  },
  props: ['vector'],  
  data () {
    return {
      usuariosTodos: null
    }
  },
  methods:{
  	getUsuarios(){
  		// checa si tiene autorizacion
  		if(!this.vector.includes('MASTERGGUV')){
	  		if(!this.vector.includes('Usuarios')){
	  			alert('Seccion no autorizada');
	  			return;
	  		}
	  	}
  		axios.get('https://www.directodo.com/Rentus/accesosdb/leeUsuarios.php')
  		     .then((respuesta) => {
  		     	this.usuariosTodos=respuesta.data;
  			 });
  	}
  }
}
</script>

<style lang="scss">
	#propiedades-lista{
		padding:20px;
		li{
			width: 100%;
			height: 100%;
			background: #eee;
			text-align: left;
			overflow: hidden;
		}
	}
</style>




// WEBPACK FOOTER //
// src/Usuarios.vue